import PropTypes from "prop-types";
import { Box, Stack, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export const FavouriteActions = ({ onDone, onRemove, disabled }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 3, py: 2 }}>
      <Stack spacing={1.5}>
        <Stack direction="row" spacing={1.5}>
          <Button
            fullWidth
            variant="contained"
            onClick={onDone}
            disabled={disabled}
          >
            {t("favourites.done")}
          </Button>
          <Button fullWidth variant="outlined" color="error" onClick={onRemove}>
            {t("favourites.remove")}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

FavouriteActions.propTypes = {
  onDone: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
